import type { StatusFilter } from "./ProspectFilters";
/** Viste di lavoro: ciascuna corrisponde a un passo del flusso operatore. */
export const WORK_VIEWS = {
  da_controllare: { status: "omonimi_found", minImmobili: 0 },
  con_immobili: { status: "visura_ok", minImmobili: 1 },
  nessuna: { status: "no_match", minImmobili: 0 },
  tutte: { status: "", minImmobili: 0 },
} as const satisfies Record<string, { status: StatusFilter; minImmobili: number }>;
export type WorkView = keyof typeof WORK_VIEWS;

export function isWorkView(value: string | undefined): value is WorkView {
  return !!value && value in WORK_VIEWS;
}
